import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

// Icons
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import UpdateRoundedIcon from "@mui/icons-material/UpdateRounded";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import PostAddRoundedIcon from "@mui/icons-material/PostAddRounded";
import SendAndArchiveRoundedIcon from '@mui/icons-material/SendAndArchiveRounded';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export default function LegalFile() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("generar cedula notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Generar Cedulas de Notificación"
              subtitle="Generar cedulas de notificación mediante archivo excel"
              icon={<PostAddRoundedIcon />}
              color="#054360"
              to="/legalFile/notification/certificates/generate"
            />
          </Grid>
        )}

        {hasPermission("subir cedulas notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Subir Cedulas de Notificación"
              subtitle="Migrar cedulas de notificación mediante archivo zip con pdf's"
              icon={<UploadFileRoundedIcon />}
              color="#0ea5e9"
              to="/legalFile/notification/certificates/upload"
            />
          </Grid>
        )}

        {hasPermission("ver cedulas notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver Cedulas de Notificación"
              subtitle="Ver cedulas de notificación cargadas"
              icon={<FolderOpenRoundedIcon />}
              color="#10b981"
              to="/legalFile/notification/certificates/manager"
            />
          </Grid>
        )}

        {hasPermission("ver cedulas notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar Cedulas de Notificación Enviadas"
              subtitle="Lector de códigos de barra para cargar cedulas de notificación enviadas"
              icon={<SendAndArchiveRoundedIcon />}
              color="#025338"
              to="/legalFile/notification/certificates/barcode"
            />
          </Grid>
        )}

        {/* {hasPermission("subir cedulas notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar Cedulas de Notificación a SAC"
              subtitle="Migrar cedulas de notificación mediante archivo excel para cargarlas al SAC"
              icon={<CloudUploadIcon />}
              color="#c6890e"
              to="/legalFile/notification/certificates/uploadOnline"
            />
          </Grid>
        )} */}

        {hasPermission("reporte cedula notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reportes"
              subtitle="Exportar datos de cedulas de notificación"
              icon={<AssessmentRoundedIcon />}
              color="#8b5cf6"
              to="/legalFile/notification/certificates/report"
            />
          </Grid>
        )}

        {hasPermission("ver cedulas notificacion fallidas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="No procesados"
              subtitle="Archivos / cedulas de notificacion fallidas"
              icon={<ErrorOutlineRoundedIcon />}
              color="#ef4444"
              to="/legalFile/notification/certificates/failures"
            />
          </Grid>
        )}

        {hasPermission("ver cedulas notificacion sin vincular") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="No vinculadas"
              subtitle="Cedulas de notificacion sin vincular"
              icon={<ErrorOutlineRoundedIcon />}
              color="#ef9a44"
              to="/legalFile/notification/certificates/unlinked"
            />
          </Grid>
        )}
        
        {hasPermission("eliminar cedulas notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Eliminar Cedulas"
              subtitle="Eliminar cedulas de notificación"
              icon={<UpdateRoundedIcon />}
              color="#2563eb"
              to="/legalFile/notification/certificates/update"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
